import { Stack } from "@genius-tracker/design-system";
import { useLocale } from "@genius-tracker/i18n/react";

import { AskGeniusSummary } from "./AskGeniusSummary.js";
import type { GtccViewDef } from "./registry.js";

interface AskGeniusPanelProps {
  readonly view: GtccViewDef;
  readonly enabled: boolean;
}

/** Read-only content of the global, view-aware Ask Genius header drawer. */
export function AskGeniusPanel({ view, enabled }: AskGeniusPanelProps) {
  const { t } = useLocale();
  return (
    <Stack gap={4} data-testid="gtcc-ask-genius-panel">
      <Stack gap={1}>
        <h2 style={{ margin: 0, fontSize: "var(--gt-sys-font-size-lg)" }}>
          {t("admin.gtcc.ask_genius")}
        </h2>
        <p
          data-testid="gtcc-ask-genius-active-view"
          style={{ margin: 0, color: "var(--gt-sys-text-muted)" }}
        >
          {t(view.label)}
        </p>
      </Stack>
      <AskGeniusSummary summaryKey={view.askGeniusSummary} enabled={enabled} />
    </Stack>
  );
}
